import React, { useState, useEffect } from "react";
import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { useNavigate } from "react-router-dom";
import { Button } from "primereact/button";
import RenderWysiwyg from "render-wysiwyg";

export default function LivraisonTable({ projets }) {
    const [nodes, setNodes] = useState([]);
    const navigate = useNavigate();
    useEffect(() => {
        if (projets) {
            const formattedProjects = projets.map((proj, index) => ({
                key: index,
                data: {
                    id: proj.id,
                    titre: proj.titre,
                    description: proj.description.length > 20 ? proj.description.substring(0, 20) + "..." : proj.description,
                    coach: proj.assigned_to_name || "Non assigné",
                    user_email: proj.user_email,
                },
            }));

            setNodes(formattedProjects);
        }
    }, [projets]);

    const actionTemplate = (node) => (
        <Button
            label="Voir livrables"
            icon="pi pi-eye"
            className="text-sm font-thin p-button-secondary bg-orange p-2 text-white"
            onClick={() => navigate(`${node.data.id}`)}
        />
    );

    const descriptionTemplate = (node) => (
        <div className="wysiwyg-content"><RenderWysiwyg content={node.data.description} /></div>
    );

    return (
        <div className="card overflow-x-auto max-md:w-full">
            <TreeTable value={nodes} paginator rows={5} rowsPerPageOptions={[5, 10, 25]}  className="min-w-[100rem] max-md:min-w-[30rem]" >
                <Column field="titre" header="Nom du projet" expander  />
                <Column body={descriptionTemplate} header="Description" className="max-md:hidden"/>
                <Column field="coach" header="Coach" className="max-md:hidden" />
                <Column field="user_email" header="Email du porteur" className="max-md:hidden" />
                <Column body={actionTemplate} header="Actions"></Column>
            </TreeTable>
        </div>
    );
}
